module.exports = __webpack_public_path__ + "static/img/NestBloom_Logo.bdc77b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/NestBloom_Logo.png
// module id = JFu5
// module chunks = 0